import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';

/**
 * TodaySealedTitle — 한글 친근화 (라벨 Pretendard + 숫자 mono).
 * uppercase·heavy tracking 제거.
 */

export const title = style({
  display: 'inline-flex',
  alignItems: 'baseline',
  gap: '0.4em',
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: '0.75rem',
  fontWeight: String(600),
  color: vars.bright.primary.light,
});

export const meta = style({
  display: 'inline-flex',
  alignItems: 'baseline',
  gap: '0.15em',
  fontFamily: vars.typography.fontFamily.mono,
  fontVariantNumeric: 'tabular-nums',
  color: vars.typography.textColor.tertiary,
});

// 카운터의 기준 라벨(입사·정규직) — 숫자가 아니므로 mono를 벗기고 Pretendard로 둔다
// (모티프 규약: 라벨은 Pretendard, 숫자는 mono). 색은 meta와 같은 tertiary로 맞춰
// 자기 숫자와 한 덩어리로 읽히게 한다 — 제목("오늘 일지")보다 앞으로 나오면 안 된다.
export const metaLabel = style({
  fontFamily: vars.typography.fontFamily.primary,
  color: vars.typography.textColor.tertiary,
});

export const separator = style({
  color: vars.typography.textColor.disabled,
  margin: '0 0.2em',
});
